import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { ViewerModalComponent } from './viewer-modal.component';

// Substituto in-repo do NgxIonicImageViewerModule (ver viewer-modal.component.ts).
@NgModule({
	imports: [CommonModule, IonicModule, TranslateModule],
	declarations: [ViewerModalComponent],
	exports: [ViewerModalComponent],
})
export class MpImageViewerModule {}
